import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { NavBarRoute } from 'components/Layout/AuthedLayout/AuthedHeader/NavigationBar/types';

interface NavigationItemProps {
  route: string;
  onClick?: () => void;
}

const NavigationItem: React.FC<NavigationItemProps> = ({ route, children }): JSX.Element => {
  return (
    <NavLink to={route}>
      {({ isActive }) => (
        <Button as="li" variant="navItem">
          <Icon
            className={cx('w-8 mr-8', {
              'opacity-0': !isActive,
            })}
            name="CirclesTarget"
          />
          {children}
        </Button>
      )}
    </NavLink>
  );
};

type Props = {
  navigationItems: NavBarRoute[];
};

export const DesktopNavigationBar: React.FC<Props> = ({ navigationItems }) => {
  const { t } = useTranslation();

  return (
    <ul className="flex gap-24 2xl-d:hidden">
      {navigationItems.map(({ label, route }) => (
        <NavigationItem route={route} key={route}>
          {t(label)}
        </NavigationItem>
      ))}
    </ul>
  );
};
